import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'global',
    viewPath: props.viewPath,
  })
  return function onClick() {
    submit({
      type: 'tabs/add',
      tab: {
        type: 'Tasks',
        id: 'Tasks',
        name: 'Tasks',
        viewPath: '/App/Account/Content/Tasks',
        visible: false,
        selected: {},
      },
    })
  }
}
